var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.4774 218.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: .6;\n      }\n\n      .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        opacity: .3;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.7235,
    y1: 86.9631,
    x2: 109.6677,
    y2: -122.0535,
    gradientTransform: "translate(-.2166 123.4963) rotate(-5) skewX(-4.9622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74a900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#74a900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#91d303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#8fcf0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#8bc91f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5897,
    stopColor: "#86c037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    stopColor: "#84bd41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6986,
    stopColor: "#84be3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#86c233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    stopColor: "#8ac821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9401,
    stopColor: "#8fd109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9639,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    stopColor: "#8ccc17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#86c135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84bd41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.5836,
    y1: -60.982,
    x2: 115.5959,
    y2: 41.2301,
    gradientTransform: "translate(-.2166 123.4963) rotate(-5) skewX(-4.9622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74a900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.7613,110.6073c0-18.2078,14.8938-41.8467,33.0918-52.5393L131.3618,15.9782c9.1697-5.3888,17.4923-6.4927,23.5034-3.9457l-16.3112-8.3248c-6.0043-2.5115-14.304-1.393-23.444,3.9767L39.6013,49.7741C21.4033,60.4667,6.5095,84.109,6.5095,102.3168v105.6548l16.2518,8.2905v-105.6548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.8531,58.068L131.3618,15.9782c18.201-10.6963,33.0952-4.554,33.0952,13.6505v39.4712c0,18.1977-14.8942,41.8433-33.0952,52.5362l-75.5087,42.0863c-18.198,10.6926-33.0918,34.3383-33.0918,52.5396v-105.6548c0-18.2078,14.8938-41.8467,33.0918-52.5393h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.3373,100.2369c-.8374.4835-1.6488,1.311-2.3041,2.3452-.6957-.857-1.8204-.9528-3.0415-.2478-.882.5092-1.7267,1.3891-2.3973,2.4926-.7011-.7532-1.791-.8091-2.9482-.141-.5693.3287-1.1307.8186-1.6383,1.4273l-.0042-9.9197c-.0046-2.5497-1.6557-3.7104-3.6802-2.5876-.9526.5211-1.8722,1.4989-2.5859,2.7395-.786,1.3671-1.2356,2.9212-1.233,4.2635l.0399,21.6911-1.6688-1.5228c-1.4138-1.2906-3.7124-.6486-5.721,1.6003-.7124.7971-1.2608,1.8239-1.5442,2.8917-.2956,1.1134-.2619,2.1564.0922,2.8611.0102.0209.0214.0405.0333.0594l9.6623,15.1993c.9589,1.5085,2.7279,1.7682,4.6166.6778l11.4736-6.6243c2.2686-1.3098,4.2605-4.4982,4.7363-7.5811,1.2076-7.8219,1.8198-15.4858,1.8198-22.7793v-4.3161c0-2.5747-1.663-3.7092-3.7073-2.5289v-.0002ZM48.6201,124.6173l-.0462-25.2082c-.0012-.6902.2227-1.4765.6145-2.1576.3106-.5403.6994-.9591,1.0947-1.1775.9084-.5038,1.6492.0872,1.6515,1.3174l.0043,19.2071c0,.6743.4642.9548,1.0346.6254s1.0345-1.1458,1.0345-1.82v-5.1026c0-1.2265.7348-2.6488,1.6382-3.1703s1.6382.0522,1.6382,1.2787v5.8724c0,.6739.4642.9544,1.0346.6251s1.0345-1.1458,1.0345-1.8197c0-.3936.0062-4.9831.0146-5.4439.108-1.1607.806-2.3922,1.6236-2.8642.9034-.5216,1.6382.0518,1.6382,1.2783v6.1613c0,.6739.4642.9544,1.0346.6251.5704-.3293,1.0346-1.1458,1.0346-1.8198v-5.1724c0-1.2265.7348-2.6484,1.6381-3.1699s1.6381.0519,1.6381,1.2784v4.3161c0,7.1328-.5986,14.6275-1.7792,22.2755-.2831,1.8334-1.4217,3.7026-2.7077,4.4451l-11.4736,6.6243c-1.1337.6546-2.2078.4794-2.8031-.4576l-9.639-15.1605c-.1169-.2512-.1249-.6177-.0221-1.0049.0912-.3435.2569-.6622.4665-.8968.3506-.3922.7179-.6962,1.0824-.9066.806-.4653,1.5969-.4724,2.1552.0374l3.5203,3.2125c.2738.2494.737.141,1.1521-.2709.4155-.4114.6941-1.0374.6931-1.5568h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.4659,114.1789c.1607.0211.3444-.0246.5312-.1324.362-.209.7024-.6333.888-1.1069.1422-.3617.1835-.7144.1165-.9927-.0671-.2779-.2347-.4483-.4716-.4793-3.387-.4443-5.4091-3.4953-5.4091-8.1619,0-7.2498,4.9912-16.0296,11.1263-19.5718,6.1351-3.5421,11.1264-.5256,11.1264,6.7242,0,2.0672-.3929,4.2707-1.1677,6.5497-.255.7503-.0473,1.3664.4629,1.3732.2474.0032.5278-.1342.7901-.39.2622-.2548.4745-.595.598-.9585.9196-2.7052,1.3859-5.3193,1.3859-7.7689,0-8.5979-5.9194-12.1752-13.1955-7.9744-7.276,4.2008-13.1954,14.6133-13.1954,23.2112,0,5.5338,2.3978,9.152,6.4141,9.6787v-.0002h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.5014,98.3139c.075.2709.249.4315.4901.452.1545.0129.3292-.0338.5049-.1352.3742-.2161.7205-.6553.9034-1.1467.6816-1.8305,1.042-3.6749,1.042-5.3333,0-5.3395-3.676-7.5611-8.1945-4.9523s-8.1946,9.0751-8.1946,14.4146c0,1.536.3117,2.8849.9015,3.9014.1264.2176.3408.3087.6039.2568.2632-.0516.5435-.2412.7891-.5322.2459-.2911.4279-.6494.5124-1.0091.0845-.3597.0616-.6776-.0648-.8952-.4464-.7695-.6727-1.7507-.6727-2.9165,0-3.9913,2.7478-8.8247,6.1254-10.7747s6.1254-.2896,6.1254,3.7018c0,1.2404-.2689,2.6188-.7779,3.9855-.1351.3628-.1683.7121-.0934.9831h-.0002Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.6318,104.5421c1.6196.8652,4.2109.9531,7.5591-.9805,3.8872-2.2441,5.2554-5.0137,5.2554-6.7422,0-2.5195-2.7358-1.6592-5.7954-.6846-3.8516,1.2158-8.3154,2.6768-8.3154-2.2188,0-3.959,3.4922-8.8555,8.4956-11.7441,3.7075-2.1406,6.6235-2.6357,8.7471-1.7021l-2.0879,3.8691c-1.8354-.8848-4.3555-.293-6.9468,1.2031-2.6641,1.5381-4.5005,3.9658-4.5005,5.9814,0,2.1602,2.5923,1.3467,5.5796.3779,3.9238-1.2217,8.4951-2.6357,8.4951,2.4756,0,3.7432-2.5913,8.7305-9.0703,12.4707-4.2837,2.4736-7.4155,2.7334-9.4673,1.6504l2.0518-3.9561Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.6631,104.6007l-3.2393,1.8701v-24.0088l3.2393-1.8701v2.4834c1.2603-2.4551,3.3477-4.8477,5.6875-6.1982,4.5356-2.6191,7.7393-1.0498,7.7393,4.6377s-3.2036,10.9922-7.7393,13.6113c-2.2671,1.3086-4.2837,1.4287-5.6875.332v9.1426ZM106.4873,80.254c-1.98,1.1436-3.96,3.4385-4.8242,5.3408v7.3799c.8643.8682,2.8442.9141,4.8242-.2295,3.2393-1.8701,5.2188-5.6406,5.2188-9.2764,0-3.5996-1.9795-5.085-5.2188-3.2148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.1216,82.7022v-1.9082c-1.3672,2.3018-3.3472,4.2725-5.6875,5.623-2.8794,1.6631-6.0469,1.5479-6.0469-2.2676,0-3.96,3.1318-7.4951,6.0469-9.1787,2.3403-1.3511,4.3555-1.7588,5.6875-.98v-2.8799c0-2.1592-1.7632-2.437-4.2471-1.0029-1.98,1.1431-3.6719,2.876-5.2197,5.3174l-1.4038-1.4219c1.9443-3.0298,4.3198-5.3369,7.1274-6.958,3.7798-2.1821,6.9834-2.3765,6.9834,2.0513v11.7344l-3.2402,1.8711ZM128.1216,75.9342c-.9717-.7339-2.6631-.4419-4.4634.5977-2.3394,1.3511-3.9956,3.7114-3.9956,5.7632s1.6562,2.499,3.9956,1.1484c1.8003-1.04,3.4917-2.7002,4.4634-4.5566v-2.9526Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.db4089ea350b2b7e449df155e8aff679.svg";
export { ForwardRef as ReactComponent };